<template lang="pug">
  include ../../../pug/mixins/bem
  div
    slot(
      :show='showImg'
    )
    vue-easy-lightbox(
      :visible="visible"
      :index='index'
      :imgs="imgs"
      @hide="handleHide"
    )    
</template>
<script>
import VueEasyLightbox from 'vue-easy-lightbox' 
export default {
  name: 'Lightbox',
  props: {
    imgs: {
      type: Array
    },
  },
  components: {
    VueEasyLightbox
  },
  data() {
    return {
      visible: false,
      index: 0,
    }
  },
  methods: {
    showImg(idx) {
      this.index = idx
      if (this.imgs.length) {
        this.visible = true
      }
    },
    handleHide() {
      this.visible = false
    },
  }
}
</script>


// WEBPACK FOOTER //
// src/js/shared/components/Lightbox.vue